import { useQuery } from 'react-query'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useDeliveryPoints = (
  { lat, lng, address, city, postalCode, countryCode, dimensions, range },
  formatMessage,
) => {
  const authedFetch = useAuthedFetch()

  const addressToUse = address !== '' ? address : city

  const query = useQuery(
    [
      'distribution-points',
      lat,
      lng,
      addressToUse,
      city,
      postalCode,
      countryCode,
      dimensions,
      range,
    ],
    () =>
      withFetchCancel(signal =>
        authedFetch('POST', `${BACKEND_ENDPOINT}/distribution-points/search`, {
          parseJSON: true,
          signal,
          data: {
            area: {
              city: city,
              postal_code: postalCode,
              country_code: countryCode,
            },
            location: {
              address: addressToUse,
              latitude: lat,
              longitude: lng,
              max_range: range,
            },
            dimensions: dimensions,
            type: "OFFLINE"
          },
        }),
      ),
    {
      enabled:
        Boolean(lat) &&
        Boolean(lng) &&
        Boolean(addressToUse) &&
        Boolean(city) &&
        Boolean(postalCode) &&
        Boolean(countryCode),
      select: ({ data: deliveryPoints }) => {
        return deliveryPoints.data.map(address => ({
          lat: address.address.gps_latitude,
          lng: address.address.gps_longitude,
          name: address.point_name,
          detailedAddress: address.address,
          address: `${address.address.address}, ${address.address.postal_code}, ${address.address.address_2}, ${address.address.country_code}`,
          phoneNumber: address.phone_number,
          organicPointCode: address.organic_point_code,
          schedule: address.opening_hours_array.map(schedule => {
            const hours = schedule.hours.map(hour => {
              return `${hour.from}-${hour.to}`
            })

            return {
              dayName: formatMessage(`weekday:${schedule.day_of_week}`),
              openingHours: hours.join(', '),
            }
          }),
        }))
      },
    },
  )

  return query
}

export default useDeliveryPoints
